import * as React from 'react';
const classNames = require('classnames');

export interface Option {
	value: string;
	text: string;
}

interface Props {
	className?: string;
	contentClassName?: string;
	children?: {};
	isOpen: boolean;
}

interface State {}

class FormCheckConditional extends React.Component<Props, State> {
	render() {
		const { className, contentClassName, children, isOpen } = this.props;
		return isOpen ? (
			<div className={classNames('form-check-conditional', className)}>
				<div className="form-check-conditional-content-wrapper">
					<div className={classNames('form-check-conditional-content', contentClassName)}>{children}</div>
				</div>
			</div>
		) : null;
	}
}

export default FormCheckConditional;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/FormCheckConditional.tsx